import React, {useContext, useEffect, useState} from 'react'
import {CardMedia, FormControlLabel, Radio} from '@mui/material'
import {clearText, isEmpty} from 'react-lf-tools'
import {getLocal} from '../../../../hooks/useStorage/useStorage.jsx'
import {general as textsGeneral} from '../../../../translate/Translate.jsx'
import {ItemBagContext} from '../../../../context/ItemBagContext.jsx'
import {titleColor} from '../../../../metrics.module.scss'

import './stepOptional.scss'

const StepOptional = ({title, options, step, stepIndex, priceStep, onClick: handleClick}) => {
    let {optional, setOptional, item, isEdit} = useContext(ItemBagContext)
    const [sku, setSku] = useState('')
    const [settings, setSettings] = useState({
        showPhoto: false
    })
    const handleChange = (option) => {
        option.valuePercentage = option.price
        option.priceProduct = option.price
        option.amount = 1
        option.step = step
        option.stepIndex = stepIndex
        option.priceStep = priceStep
        optional[stepIndex] = [option]
        setSku(option.sku)
        setOptional({...optional})
        handleClick()
    }
    const checkOptions = () => {
        if (isEdit) {
            findOptionBySku(options, item)
        }
    }
    const findOptionBySku = (options, item) => {
        for (const s in item.subitems) {
            for (const o in options) {
                if (options[o].sku === item.subitems[s].sku) {
                    return addOptional(item.subitems[s])
                }
            }
        }
    }
    const addOptional = (option) => {
        option.valuePercentage = option.price
        option.amount = 1
        option.step = step
        option.stepIndex = stepIndex
        option.priceStep = priceStep
        optional[stepIndex] = [option]
        setSku(option.sku)
        setOptional({...optional})
    }
    useEffect(() => {
        checkOptions()
    }, [])
    useEffect(() => {
        const data = getLocal('data')
        setSettings({
            showPhoto: data?.showPhoto,
            showDescription: data?.showDescription
        })
    }, [])
    return <div className={'step-optional'}>
        <div className={'card-step'} id={`step${stepIndex}`}>
            <div className={'div-title-step'}>
                <label className={'label-title-step'}>
                    {title}
                </label>
                <div className={'div-title-mandatory'}>
                    {(sku === '') && <div className={'div-mandatory-step'}>
                        <label className={'label-mandatory-step'}>
                            {textsGeneral.mandatory}
                        </label>
                    </div>}
                    {!!priceStep && <div className={'div-mandatory-step'}>
                        <label className={'label-mandatory-step'}>
                            {priceStep.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            })}
                        </label>
                    </div>}
                </div>
            </div>
            <div className={'div-items-step'}>
                {options.map((option, i) => <div className={'div-description-step'} key={i}
                                                 id={clearText(option.option)}>
                    {(settings.showPhoto) && <div className={'div-image-option'}>
                        {(!!option.image) && <CardMedia
                            image={option.image}
                            className={'card-media-step'}/>}
                    </div>}
                    <div className={'div-description-price-step'}>
                        <FormControlLabel
                            sx={{'& .MuiTypography-root': {fontFamily: 'Nunito'}}}
                            onChange={() => handleChange(option)}
                            control={<Radio checked={(option.sku === sku)}
                                            style={{color: titleColor, fontFamily: 'Nunito'}}/>}
                            label={option.option}/>
                        {(settings.showDescription || option.sku.includes('S')) &&
                            <label
                                className={'description'}>
                                {option.description}
                            </label>}
                        {(option.price !== 0) && <label className={'label-price-step'}>
                            {option.price.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            })}
                        </label>}
                        {(!isEmpty(option.oldPrice) && option.oldPrice !== 0) &&
                            <label className={'label-old-price-step'}>
                                {option.oldPrice.toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL'
                                })}
                            </label>}
                    </div>
                </div>)}
            </div>
        </div>
    </div>
}

export default StepOptional
